import { Component, OnInit } from '@angular/core';
import { Product } from '../../../dto/product';
import {Params, Router} from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ProductService } from '../../services/product.service';
import { environment } from '../../../../environments/environment';
import { RoleService } from '../../../services/role.service';

import {EventLogService} from '../../../services/crud/event-log.service';
import {EventLog} from '../../../dto/event-log';
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {Upload} from "../../../dto/upload";
import {UploadsAdminService} from "../../services/uploads-admin.service";
import {PrevNextModel} from "../../../models/prev-next-model";
import {getTableFilters} from "../../../helpers/storage-helper";
import {PrevNextIdModel} from "../../../models/prev-next-id-model";

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.css']
})
export class ProductViewComponent implements OnInit {
  product: Product;

  logoUpload: Upload|null;
  imgUpload: Upload|null;
  cleanCardImageUpload: Upload|null;

  backgroundImageUpload: Upload|null;
  overlay1ImageUpload: Upload|null;
  overlay2ImageUpload: Upload|null;
  overlay3ImageUpload: Upload|null;
  overlay4ImageUpload: Upload|null;

  virtualOnlyBackgroundImageUpload: Upload|null;
  virtualOnlyOverlay1ImageUpload: Upload|null;
  virtualOnlyOverlay2ImageUpload: Upload|null;
  virtualOnlyOverlay3ImageUpload: Upload|null;
  virtualOnlyOverlay4ImageUpload: Upload|null;


  fields = [
    { header: 'Internal Name', cell: (row: Product) => `${row.internalName}` },
    { header: 'Name', cell: (row: Product) => `${row.name}` },
    { header: 'Short Name', cell: (row: Product) => `${row.shortName}` },
    { header: 'Company', cell: (row: Product) => `${row.companyName || ''}` },
    { header: 'Partner Price', cell: (row: Product) => `${row.partnerPrice.formatMoneyEuro()}` },

    { header: 'Cancellation period (days)', cell: (row: Product) => `${row.cancellationPeriodDays || ''}` },
    { header: 'Minimal contract period (months)', cell: (row: Product) => `${row.minimalContractPeriodMonths || ''}` },
    { header: 'Active', cell: (row: Product) => row.active ? 'YES' : 'NO' },
    { header: 'Product ID', cell: (row: Product) => `${row.productId || ''}` },

  ];

  fieldsLoads = [
    { header: 'Instant loads enabled', cell: (row: Product) => `${row.isInstantLoadEnabled ? 'Yes' : 'No'}`,
     iconColor: (row: Product) => row.isInstantLoadEnabled ? 'forestgreen':'red' ,
     icon: (row: Product) => row.isInstantLoadEnabled ? 'check': 'close' },
  ] as ContentRowField<Product>[];

  fieldsAppearance = [
    { header: 'Dark Text', cell: (row: Product) => `${row.textDark ? 'Yes' : 'No'}`,
      iconColor: (row: Product) => row.textDark ? 'black':'gray' ,
      icon: (row: Product) => row.textDark ? 'check': 'close' },
  ] as ContentRowField<Product>[];


  fieldsFees = [
    { header: 'Annual Fee', cell: (row: Product) => `${row.annualFee.formatMoneyEuro()}` },
    { header: 'Annual Fee from 2nd year', cell: (row: Product) => `${row.annualFeeFromSecondYear.formatMoneyEuro()}` },
    { header: 'Issuing Fee', cell: (row: Product) => `${row.issuingFee.formatMoneyEuro()}` },

    { header: 'First months free', cell: (row: Product) => `${row.firstMonthsFree}` },

    { header: 'Under 26 - promotion active', cell: (row: Product) => `${row.under26PromotionActive ? 'YES' : 'NO'}`

      , iconColor: (row: Product) => row.under26PromotionActive ? 'forestgreen':'red'
      , icon: (row: Product) => row.under26PromotionActive ? 'check': 'close'

    },
    { header: 'Annual Fee - Under 26', cell: (row: Product) => `${row.annualFeeUnder26?.formatMoneyEuro() || '-'}`},
    { header: 'Annual Fee from 2nd year - Under 26', cell: (row: Product) => `${row.annualFeeFromSecondYearUnder26?.formatMoneyEuro() || '-'}` },


    { header: 'SEPA Load fee Percent', cell: (row: Product) => `${row.loadFeePercent}` },
    { header: 'SEPA Load fee Fixed', cell: (row: Product) => `${row.loadFeeFixed.formatMoneyEuro()}` },
    { header: 'SEPA Load fee Minimum', cell: (row: Product) => `${row.loadFeeMinimum.formatMoneyEuro()}` },
    { header: 'SEPA Load fee Maximum', cell: (row: Product) => `${row.loadFeeMaximum != null ? row.loadFeeMaximum.formatMoneyEuro() : '-'}` },

    { header: 'Wallet Load fee Percent', cell: (row: Product) => `${row.walletLoadFeePercent}` },
    { header: 'Wallet Load fee Fixed', cell: (row: Product) => `${row.walletLoadFeeFixed.formatMoneyEuro()}` },
    { header: 'Wallet Load fee Minimum', cell: (row: Product) => `${row.walletLoadFeeMinimum.formatMoneyEuro()}` },
    { header: 'Wallet Load fee Maximum', cell: (row: Product) => `${row.walletLoadFeeMaximum != null ? row.walletLoadFeeMaximum.formatMoneyEuro() : '-'}` },


    { header: 'C2C Send fee Percent', cell: (row: Product) => `${row.cardToCardFeePercent}` },
    { header: 'C2C Send fee Fixed', cell: (row: Product) => `${row.cardToCardFeeFixed.formatMoneyEuro()}` },
    { header: 'C2C Send fee Minimum', cell: (row: Product) => `${row.cardToCardFeeMinimum.formatMoneyEuro()}` },
    { header: 'C2C Send fee Maximum', cell: (row: Product) => `${row.cardToCardFeeMaximum != null ? row.cardToCardFeeMaximum.formatMoneyEuro() : '-'}` },

    { header: 'C2C Receive fee Percent', cell: (row: Product) => `${row.cardToCardReceiveFeePercent}` },
    { header: 'C2C Receive fee Fixed', cell: (row: Product) => `${row.cardToCardReceiveFeeFixed.formatMoneyEuro()}` },
    { header: 'C2C Receive fee Minimum', cell: (row: Product) => `${row.cardToCardReceiveFeeMinimum.formatMoneyEuro()}` },
    { header: 'C2C Receive fee Maximum', cell: (row: Product) => `${row.cardToCardReceiveFeeMaximum != null ? row.cardToCardReceiveFeeMaximum.formatMoneyEuro() : '-'}` },

    { header: 'Virtual-to-physical conversion fee', cell: (row: Product) => `${row.cardConversionFee.formatMoneyEuro()}` },

  ] as ContentRowField<Product>[];

  fieldsAnnualFeeOptions = [
    { header: 'Skip annual fee deduction', cell: (row: Product) => `${row.skipAnnualFeeDeduction ? 'Yes':'No'}`

      , iconColor: (row: Product) => row.skipAnnualFeeDeduction ? 'orange':'grey'
      , icon: (row: Product) => row.skipAnnualFeeDeduction ? 'error_outline': 'close'

    },
    { header: 'Skip annual fee invoice generation', cell: (row: Product) => `${row.skipAnnualFeeInvoiceGeneration ? 'Yes':'No'}`

      , iconColor: (row: Product) => row.skipAnnualFeeInvoiceGeneration ? 'orange':'grey'
      , icon: (row: Product) => row.skipAnnualFeeInvoiceGeneration ? 'error_outline': 'close'

    },

    { header: 'Debt collection enabled', cell: (row: Product) => `${row.isDebtCollectionEnabled ? 'Yes':'No'}`

      , iconColor: (row: Product) => row.isDebtCollectionEnabled ? 'forestgreen':'red'
      , icon: (row: Product) => row.isDebtCollectionEnabled ? 'check': 'close'

    },

  ] as ContentRowField<Product>[];

  fieldsCashback = [
    { header: 'Active', cell: (row: Product) => `${row.cashbackActive ? 'Yes':'No'}` },
    { header: 'Factor', cell: (row: Product) => `${row.cashbackFactor} (=${row.cashbackFactor * 100}%)` },
    { header: 'Max per Month', cell: (row: Product) => `${row.cashbackMaxPerMonth}` },
    { header: 'Max per Transaction', cell: (row: Product) => `${row.cashbackMaxPerTransaction}` },

  ] as ContentRowField<Product>[];

  fieldsApps = [
    { header: 'Show Play Store Icon', cell: (row: Product) => `${row.showPlayStoreIcon ? 'Yes':'No'}` },
    { header: 'Play Store Link', cell: (row: Product) => `${row.playStoreLink}` },
    { header: 'Show App Store Icon', cell: (row: Product) => `${row.showAppStoreIcon ? 'Yes':'No'}` },
    { header: 'Play App Link', cell: (row: Product) => `${row.appStoreLink}` },
    { header: 'App Brands', cell: (row: Product) => `${row.appsList}` },
  ] as ContentRowField<Product>[];

  fieldsCardCreation = [

    { header: 'Card design', cell: (row: Product) => `${row.cardDesign || ''}` },
    { header: 'Card design Virtual', cell: (row: Product) => `${row.cardDesignVirtual || ''}` }, // only if different than physical
    { header: 'Create Type', cell: (row: Product) => `${row.createType || ''}` },
    { header: 'FDD Limit group', cell: (row: Product) => `${row.limitsGroup || ''}` },
    { header: 'FDD Perms group', cell: (row: Product) => `${row.permsGroup || ''}` },

    { header: 'EDD Limit group', cell: (row: Product) => `${row.eddLimitGroup || ''}` },
    { header: 'EDD Perms group', cell: (row: Product) => `${row.eddPermsGroup || ''}` },

    { header: 'SDD Creation active', cell: (row: Product) => `${row.isNoIdentCreationActive ? 'Yes' : 'No'}` },
    { header: 'SDD Card design', cell: (row: Product) => `${row.isNoIdentCreationActive ? row.cardDesignNoIdent || '' : '(inactive)'}` },
    { header: 'SDD Create Type', cell: (row: Product) => `${row.isNoIdentCreationActive ? row.createTypeNoIdent || '' : '(inactive)'}` },
    { header: 'SDD Limits group', cell: (row: Product) => `${row.isNoIdentCreationActive ? row.limitsGroupNoIdent || '' : '(inactive)'}` },
    { header: 'SDD Perms group', cell: (row: Product) => `${row.isNoIdentCreationActive ? row.permsGroupNoIdent || '' : '(inactive)'}` },
    { header: 'Convert to physical on Ident', cell: (row: Product) => `${row.convertToPhysicalAfterIdent ? 'Yes' : 'No'}` },


    { header: 'Product ref', cell: (row: Product) => `${row.productRef || ''}` },
    { header: 'Curr code', cell: (row: Product) => `${row.currCode || ''}` },
    { header: 'Lang', cell: (row: Product) => `${row.lang || ''}` },
    { header: 'Load value', cell: (row: Product) => `${row.loadValue || ''}` },
    { header: 'Instant convert to physical', cell: (row: Product) => `${row.createConvertToPhysical ? 'Yes' : 'No'}` },
    { header: 'Image Id', cell: (row: Product) => `${row.imageId || ''}` },
    { header: 'Fee group', cell: (row: Product) => `${row.feeGroup || ''}` },
    { header: 'Carrier type', cell: (row: Product) => `${row.carrierType || ''}` },
    { header: 'Sms required', cell: (row: Product) => `${row.smsRequired || ''}` },
    { header: 'Mail or sms', cell: (row: Product) => `${row.mailOrSms || ''}` },
    { header: 'Action', cell: (row: Product) => `${row.action || ''}` },
    { header: 'Delv method', cell: (row: Product) => `${row.delvMethod || ''}` },
    { header: 'Allow List (Whitelist)', cell: (row: Product) => `${row.whiteListCode || ''}` },
    { header: 'Deny List (Blacklist)', cell: (row: Product) => `${row.blackListCode || ''}` },

    { header: 'Display Design', cell: (row: Product) => `${row.displayDesign || ''}` },
    { header: 'Virtual only', cell: (row: Product) => `${row.virtualOnly ? 'Yes' : 'No'}` },


  ] as ContentRowField<Product>[];

  fieldsProductLimits = [

    { header: 'SDD Daily Max Load', cell: (row: Product) => `${row.sddDailyLoadLimit}` },
    { header: 'SDD Monthly Max Load', cell: (row: Product) => `${row.sddMonthlyLoadLimit}` },
    { header: 'SDD Yearly Max Load', cell: (row: Product) => `${row.sddYearlyLoadLimit}` },
    { header: 'SDD Daily Load Frequency', cell: (row: Product) => `${row.sddDailyLoadFrequency}` },
    { header: 'SDD Monthly Load Frequency', cell: (row: Product) => `${row.sddMonthlyLoadFrequency}` },
    { header: 'SDD Yearly Load Frequency', cell: (row: Product) => `${row.sddYearlyLoadFrequency}` },

    { header: 'FDD Daily Max Load', cell: (row: Product) => `${row.fddDailyLoadLimit}` },
    { header: 'FDD Monthly Max Load', cell: (row: Product) => `${row.fddMonthlyLoadLimit}` },
    { header: 'FDD Yearly Max Load', cell: (row: Product) => `${row.fddYearlyLoadLimit}` },
    { header: 'FDD Daily Load Frequency', cell: (row: Product) => `${row.fddDailyLoadFrequency}` },
    { header: 'FDD Monthly Load Frequency', cell: (row: Product) => `${row.fddMonthlyLoadFrequency}` },
    { header: 'FDD Yearly Load Frequency', cell: (row: Product) => `${row.fddYearlyLoadFrequency}` },

    { header: 'EDD Daily Max Load', cell: (row: Product) => `${row.eddDailyLoadLimit}` },
    { header: 'EDD Monthly Max Load', cell: (row: Product) => `${row.eddMonthlyLoadLimit}` },
    { header: 'EDD Yearly Max Load', cell: (row: Product) => `${row.eddYearlyLoadLimit}` },
    { header: 'EDD Daily Load Frequency', cell: (row: Product) => `${row.eddDailyLoadFrequency}` },
    { header: 'EDD Monthly Load Frequency', cell: (row: Product) => `${row.eddMonthlyLoadFrequency}` },
    { header: 'EDD Yearly Load Frequency', cell: (row: Product) => `${row.eddYearlyLoadFrequency}` },

  ] as ContentRowField<Product>[];




  isLoadingLogs = false;
  logs: Array<EventLog>;
  productId: number;
  prevNextIds: PrevNextIdModel|null;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private roleService: RoleService,
    private productService: ProductService,
    private uploadAdminService: UploadsAdminService,
    private logService: EventLogService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.productId = parseInt(this.route.snapshot.paramMap.get('id'));
      this.loadData();
    });
    this.productId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.loadData();

  }

  loadData() {
    this.isLoading = true;
    this.backgroundImageUpload = null;
    this.cleanCardImageUpload = null;
    this.overlay1ImageUpload = null;
    this.overlay2ImageUpload = null;
    this.overlay3ImageUpload = null;
    this.overlay4ImageUpload = null;

    this.virtualOnlyBackgroundImageUpload = null;
    this.virtualOnlyOverlay1ImageUpload = null;
    this.virtualOnlyOverlay2ImageUpload = null;
    this.virtualOnlyOverlay3ImageUpload = null;
    this.virtualOnlyOverlay4ImageUpload = null;

    this.cardPreviewUrl = null;
    this.virtualOnlyCardPreviewUrl = null;
    this.prevNextIds = null;

    this.productService.get(this.productId).subscribe(product => {
      product.logoUrl = product.logoFileName ? environment.apiUrl + product.logoFileName : null;
      this.product = product;

      if ( product.logoId )
        this.uploadAdminService.getById(product.logoId).subscribe(u => this.logoUpload = u);
      if ( product.imgId )
        this.uploadAdminService.getById(product.imgId).subscribe(u => this.imgUpload = u);
      if ( product.cleanCardImageId )
        this.uploadAdminService.getById(product.cleanCardImageId).subscribe(u => this.cleanCardImageUpload = u);

      if ( product.backgroundImageId )
        this.uploadAdminService.getById(product.backgroundImageId).subscribe(u => this.backgroundImageUpload = u);

      if ( product.overlay1ImageId )
        this.uploadAdminService.getById(product.overlay1ImageId).subscribe(u => this.overlay1ImageUpload = u);
      if ( product.overlay2ImageId )
        this.uploadAdminService.getById(product.overlay2ImageId).subscribe(u => this.overlay2ImageUpload = u);
      if ( product.overlay3ImageId )
        this.uploadAdminService.getById(product.overlay3ImageId).subscribe(u => this.overlay3ImageUpload = u);
      if ( product.overlay4ImageId )
        this.uploadAdminService.getById(product.overlay4ImageId).subscribe(u => this.overlay4ImageUpload = u);

      if ( product.virtualOnlyBackgroundImageId )
        this.uploadAdminService.getById(product.virtualOnlyBackgroundImageId).subscribe(u => this.virtualOnlyBackgroundImageUpload = u);
      if ( product.virtualOnlyOverlay1ImageId )
        this.uploadAdminService.getById(product.virtualOnlyOverlay1ImageId).subscribe(u => this.virtualOnlyOverlay1ImageUpload = u);
      if ( product.virtualOnlyOverlay2ImageId )
        this.uploadAdminService.getById(product.virtualOnlyOverlay2ImageId).subscribe(u => this.virtualOnlyOverlay2ImageUpload = u);
      if ( product.virtualOnlyOverlay3ImageId )
        this.uploadAdminService.getById(product.virtualOnlyOverlay3ImageId).subscribe(u => this.virtualOnlyOverlay3ImageUpload = u);
      if ( product.virtualOnlyOverlay4ImageId )
        this.uploadAdminService.getById(product.virtualOnlyOverlay4ImageId).subscribe(u => this.virtualOnlyOverlay4ImageUpload = u);


      if ( product.productKey && product.backgroundImageId ) {
        this.cardPreviewUrl = environment.baseUrl + 'app-product-images/combined-image/' + product.productKey;
      }

      if ( product.productKey && (product.virtualOnlyBackgroundImageId || product.virtualOnlyOverlay1ImageId || product.virtualOnlyOverlay2ImageId || product.virtualOnlyOverlay3ImageId || product.virtualOnlyOverlay4ImageId) ) {
        this.virtualOnlyCardPreviewUrl = environment.baseUrl + 'app-product-images/combined-image/' + product.productKey + "/virtual-only";
      }

    });

    if ( this.isAdmin() ) {

    }

    this.logService.get(24, this.productId).subscribe(data => {
      this.logs = data;
      this.isLoadingLogs = false;
    });

    this.getPrevNextIds(this.productId);

    this.isLoading = false;

  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route }).then();
  }

  isAdmin(): boolean {
    return this.roleService.hasRoles( 'admin' );
  }

  showLogs() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  protected readonly environment = environment;
  cardPreviewUrl: string|null;
  virtualOnlyCardPreviewUrl: string|null;
  isLoading = false;

  getPrevNextIds(id: number) {
    const filters = this.getProductTableFilters();
    this.productService.getPrevNextIds(filters, id).subscribe(result => {
      this.prevNextIds = result;
    });
  }

  getProductTableFilters() {
    return getTableFilters("productTable");
  }

  gotoPrev() {
    this.router.navigate(['../' + this.prevNextIds.prevId], { relativeTo: this.route }).then();
  }

  gotoNext() {
    this.router.navigate(['../' + this.prevNextIds.nextId], { relativeTo: this.route }).then();
  }

  goToEdit() {
    this.router.navigate(['edit'], { relativeTo: this.route }).then();
  }
}
